function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("summary").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (
    !openDetailsElement ||
    openDetailsElement.getAttribute("disabled") !== null
  )
    return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );

    this.input.addEventListener("change", this.updatePrice.bind(this));
    this.input.addEventListener("keyup", this.updatePrice.bind(this));
    this.input.addEventListener("focusout", this.setMin.bind(this));
  }

  onButtonClick(event = null) {
    if (event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === "plus"
        ? this.input.stepUp()
        : this.input.stepDown();
      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
      }
    }

    const inputs = document.querySelectorAll(
      `quantity-input input[data-product="${this.input.getAttribute(
        "data-product",
      )}"],
      quantity-input input[form="${this.input.getAttribute("form")}"]`,
    );
    inputs.forEach((input) => {
      if (
        input !== this.input &&
        input.getAttribute("id") == this.input.getAttribute("id") &&
        !input.classList.contains("bundle-option-quantity")
      ) {
        input.value = this.input.value;
        if (input.closest("product-form").querySelector("total-price")) {
          input
            .closest("product-form")
            .querySelector("total-price").dataset.quantity = this.input.value;
        }
      }
    });
    this.updatePrice();
  }

  updatePrice() {
    const priceContainer =
      this.closest("product-form")?.querySelector("total-price");
    if (priceContainer) priceContainer.dataset.quantity = this.input.value;
  }

  setMin() {
    var isCart = this.closest(".cart-item__quantity-wrapper");
    if (isCart) {
      if (this.input.value >= 1) {
        this.input.value = this.input.value;
      } else {
        this.input.value = 0;
      }
    } else if (this.input.value < 1) {
      this.input.value = 1;
    }
    this.onButtonClick();
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function getInputByValue(container, value) {
  if (!container) return null;
  const normalizedValue = String(value);

  return Array.from(container.querySelectorAll("input[value]")).find(
    (input) => input.value === normalizedValue,
  );
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();

    console.log(this);
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (
      !openDetailsElement ||
      openDetailsElement.getAttribute("disabled") !== null
    )
      return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section.section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class GaiaHeader extends HTMLElement {
  constructor() {
    super();

    let gaiaHeader = this;
    this.previousScroll = window.scrollY;

    window.addEventListener("scroll", () => {
      let headerRect = gaiaHeader.getBoundingClientRect();
      const headerHeight =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            "--header-height",
          ),
        ) || 0;
      let headerPos = 0;

      if (window.scrollY > this.previousScroll) {
        // scrolling down
        headerPos = 0 - headerRect.height;
        this.parentElement.classList.add("transparent-header");
      } else {
        // scrolling up
        if (window.scrollY <= headerHeight) {
          this.parentElement.classList.add("transparent-header");
        } else {
          this.parentElement.classList.remove("transparent-header");
        }
      }
      if (window.scrollY <= headerHeight) {
        headerPos = 0;
        this.parentElement.classList.add("transparent-header");
        this.style.top = `${headerPos}px`;
        this.previousScroll = window.scrollY;
        return;
      }
      this.style.top = `${headerPos}px`;
      this.previousScroll = window.scrollY;
    });

    this.addEventListener("click", () => {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.getBoundingClientRect().bottom)}px`,
      );
    });
    this.addEventListeners();
    this.keyboardControlClose();

    window.addEventListener("resize", () => {
      this.recheckTransparentHeader();
    });
  }

  addEventListeners() {
    const gaiaHeader = document.querySelector("gaia-header");
    const detailsElements = gaiaHeader.querySelectorAll("details");
    detailsElements.forEach((detailsElement) => {
      detailsElement.addEventListener(
        "toggle",
        this.handleDetailsToggle.bind(this),
      );
    });
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        const header = document.querySelector("gaia-header");
        if (header) {
          header.classList.add("header-loaded");
        }
      }, 3000);
    });
    // Close on escape
    document.addEventListener("keyup", (event) => {
      if (event.code === "Escape" || event.key === "Esc") {
        const gaiaHeader = document.querySelector("gaia-header");
        if (!gaiaHeader) return;
        gaiaHeader.querySelectorAll("gaia-dropdown").forEach((dropdown) => {
          if (dropdown.details && dropdown.details.hasAttribute("open")) {
            dropdown.close();
            // Optionally update aria attributes for accessibility
            const summary = dropdown.details.querySelector("summary");
            if (summary) {
              summary.setAttribute("aria-expanded", "false");
              summary.focus();
            }
          }
        });
      }
    });
  }

  // Helper to check and set transparent-header based on open details on both desktop and mobile
  recheckTransparentHeader() {
    const header = document.querySelector(".section-header");
    const gaiaHeader = document.querySelector("gaia-header");
    if (
      !header ||
      !gaiaHeader ||
      gaiaHeader.getAttribute("data-transparent") !== "true"
    )
      return;

    const isDesktop = window.matchMedia("(min-width: 1233px)").matches;
    let openDetails = [];
    // On desktop, if any of the children details are expanded
    if (isDesktop) {
      const desktopMenu = gaiaHeader.querySelector(".desktop-top-menu");
      if (desktopMenu) {
        openDetails = Array.from(desktopMenu.querySelectorAll("details[open]"));
      }
    } else {
      // on mobile, if the menu is open as a whole
      const mobileMenu = document.querySelector("gaia-mobile-menu");
      if (mobileMenu) {
        openDetails = Array.from(mobileMenu.querySelectorAll("details[open]"));
      }
    }
    // Checks to see if any details within it are open, this will maintain it then if they switch from one dropdown to another instead of closing
    const anyOpen = openDetails.length > 0;
    if (anyOpen) {
      header.classList.remove("transparent-header");
      console.log("Removed transparent-header");
    } else {
      header.classList.add("transparent-header");
      console.log("Added transparent-header");
    }
  }

  handleDetailsToggle(event) {
    setTimeout(() => {
      this.recheckTransparentHeader();

      const summary = event.target.querySelector("summary");
      if (summary) {
        // Only apply to the summary that is the first child of gaia-mobile-menu
        const gaiaMobileMenu = document.querySelector("gaia-mobile-menu");
        if (
          gaiaMobileMenu &&
          summary === gaiaMobileMenu.querySelector("summary")
        ) {
          const isOpen = event.target.hasAttribute("open");
          summary.setAttribute(
            "aria-label",
            isOpen ? "Close Main Menu" : "Open Main Menu",
          );
        } else {
          // // Fallback for other summaries
          // const isOpen = event.target.hasAttribute("open");
          // summary.setAttribute(
          //   "aria-label",
          //   isOpen ? "Close Main Menu" : "Open Main Menu"
          // );
        }
      }
    }, 100); // slight delay to ensure the DOM updates after toggle
  }

  // Accessibility support for closing the dropdowns when focus moves outside the menu (e.g keyboard controls)
  keyboardControlClose() {
    // Listen for focusin on any open details inside gaia-header
    this.addEventListener("focusin", (e) => {
      const openDetails = e.target.closest("details[open]");
      if (!openDetails || !this.contains(openDetails)) return;

      // Only add handler once per open details
      if (openDetails._tabCloseHandlerAdded) return;
      openDetails._tabCloseHandlerAdded = true;

      // Find last focusable element in .child-menu or .menu-list
      const menu =
        openDetails.querySelector(".child-menu") ||
        openDetails.querySelector(".menu-list");
      if (!menu) return;

      // Get focus elements
      const focusable = Array.from(
        menu.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex^="-"])',
        ),
      ).filter((el) => el.offsetParent !== null);

      if (!focusable.length) return;
      const last = focusable[focusable.length - 1];

      // Once at last item, close dropdown
      // const keydownHandler = (event) => {
      //   if (
      //     event.key === "Tab" &&
      //     !event.shiftKey &&
      //     document.activeElement === last
      //   ) {
      //     setTimeout(() => {
      //       // Find the gaia-dropdown element if present
      //       const gaiaDropdown = openDetails.closest("gaia-dropdown");
      //       if (gaiaDropdown && typeof gaiaDropdown.close === "function") {
      //         gaiaDropdown.close();
      //       } else {
      //         openDetails.removeAttribute("open");
      //       }
      //     }, 0);
      //   }
      // };

      // last.addEventListener("keydown", keydownHandler);

      // Clean up when details closes
      openDetails.addEventListener("toggle", function cleanup() {
        if (!openDetails.open) {
          last.removeEventListener("keydown", keydownHandler);
          openDetails._tabCloseHandlerAdded = false;
          openDetails.removeEventListener("toggle", cleanup);
        }
      });
    });
  }
}

customElements.define("gaia-header", GaiaHeader);

class GaiaDropdown extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector("summary + *");

    this.details.classList.add("closed");

    // if (this.content.getAttribute("tabindex") === null)
    // this.content.setAttribute("tabindex", "0");

    this.summary.addEventListener("click", (e) => {
      this.click(e);
    });

    this.clickOffListener = this.clickOff.bind(this);

    // // Automatically open if the dropdown has the 'desktop-expanded' class and is on desktop
    if (
      this.details.classList.contains("desktop-expanded") &&
      window.matchMedia("(min-width: 1233px)").matches
    ) {
      this.hiddenOpen();
    }

    // Watch for switches between desktop/mobile
    this.previousState = window.matchMedia("(min-width: 1233px)").matches
      ? "desktop"
      : "mobile";
    window.addEventListener("resize", this.handleResize.bind(this));

    //Reinit to fix filter issue of dropdowns not working after filter applying
    this.addEventListener("dropdown:reinit", () => {
      this.initDropdown(true);
    });
  }

  initDropdown(isReinit = false) {
    // Remove previous listeners if re-initializing
    if (isReinit && this.summary) {
      this.summary.removeEventListener("click", this._summaryClickHandler);
    }

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector("summary + *");

    if (!this.details || !this.summary || !this.content) return;

    this.details.classList.add("closed");

    if (this.content.getAttribute("tabindex") === null)
      this.content.setAttribute("tabindex", "0");

    // Store handler so it can be removed on reinit
    this._summaryClickHandler = (e) => this.click(e);
    this.summary.addEventListener("click", this._summaryClickHandler);

    this.clickOffListener = this.clickOff.bind(this);

    // Automatically open if the dropdown has the 'desktop-expanded' class and is on desktop
    if (
      this.details.classList.contains("desktop-expanded") &&
      window.matchMedia("(min-width: 1233px)").matches
    ) {
      this.hiddenOpen();
    }

    // Watch for switches between desktop/mobile
    this.previousState = window.matchMedia("(min-width: 1233px)").matches
      ? "desktop"
      : "mobile";
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  // Resize checker to see if gaia-dropdowns should be forced open (desktop) or not
  handleResize() {
    const isDesktop = window.matchMedia("(min-width: 1233px)").matches;
    const isMobile = !isDesktop;
    const currentState = isDesktop ? "desktop" : "mobile";

    // Only trigger if changed between desktop/mobile
    if (currentState !== this.previousState) {
      if (isMobile) {
        // console.log("Switching to mobile: collapsing all dropdowns");
        // Collapse all dropdowns when switching to mobile
        document.querySelectorAll("gaia-dropdown").forEach((dropdown) => {
          if (dropdown.details) {
            dropdown.close();
          }
        });
      } else if (isDesktop) {
        // Reopen dropdowns with the 'desktop-expanded' class when switching back to desktop
        document.querySelectorAll("gaia-dropdown").forEach((dropdown) => {
          if (
            dropdown.details &&
            dropdown.details.classList.contains("desktop-expanded")
          ) {
            dropdown.hiddenOpen();
          }
        });
      }
      this.previousState = currentState;
    }
  }
  clickOff(e) {
    if (this.details.open && !this.contains(e.target)) {
      this.close();
    }
  }

  click(e) {
    e.preventDefault();

    // Prevent closing if the dropdown has the class 'desktop-expanded' and is on desktop
    if (
      this.details.classList.contains("desktop-expanded") &&
      window.matchMedia("(min-width: 1233px)").matches
    ) {
      return;
    }

    if (
      this.details.open ||
      this.details.classList.contains("opening") ||
      this.details.classList.contains("open")
    ) {
      this.close();
    } else {
      this.open();
    }
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector("details");
    if (detailsElement) {
      const summaryElement = detailsElement.querySelector("summary");
      // Get the visible text from the summary (excluding SVGs/icons)
      let summaryText = "";
      summaryElement.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          summaryText += node.textContent.trim();
        }
      });
      if (!summaryText) {
        // Fallback: get all textContent, then trim
        summaryText = summaryElement.textContent.trim();
      }
      if (detailsElement.hasAttribute("open")) {
        summaryElement.setAttribute(
          "aria-label",
          `Close ${summaryText} accordion`,
        );
        summaryElement.setAttribute("aria-expanded", "true");
      } else {
        summaryElement.setAttribute(
          "aria-label",
          `Open ${summaryText} accordion`,
        );
        summaryElement.setAttribute("aria-expanded", "false");
      }
      // Optionally update detailsElement's aria-label too
      detailsElement.setAttribute(
        "aria-label",
        `${
          detailsElement.hasAttribute("open") ? "Close" : "Open"
        } ${summaryText} accordion`,
      );
    }
  }

  // This allows the desktop ones to stay expanded, but prevents the body overflow-hidden being applied
  hiddenOpen() {
    this.details.classList.remove("closed");
    this.details.classList.remove("closing");
    this.details.classList.add("opening");
    this.details.setAttribute("open", true);

    if (!this.closest("details"))
      setTimeout(() => {
        this.details.classList.remove("opening");
        this.details.classList.add("open");
      }, 300);

    this.updateAriaLabel();
    document.addEventListener("click", this.clickOffListener);
  }

  open() {
    this.details.classList.remove("closed");
    this.details.classList.remove("closing");
    this.details.classList.add("opening");
    this.details.setAttribute("open", true);

    if (!this.closest("details"))
      if (this.closest("header")) {
        document.body.classList.add("overflow-hidden");
      }
    setTimeout(() => {
      this.details.classList.remove("opening");
      this.details.classList.add("open");
      if (this.closest("header")) {
        document.body.classList.add("overflow-hidden");
      }
      if (this.classList.contains("has-modal")) {
        trapFocus(this.details, this.details.querySelector("summary"));
      }
    }, 300);

    this.updateAriaLabel();
    // resizeAllMasonryItems(".masonry-grid");
    document.addEventListener("click", this.clickOffListener);
  }

  close() {
    // Prevent closing if the dropdown has the class 'desktop-expanded' and is on desktop
    if (
      this.details.classList.contains("desktop-expanded") &&
      window.matchMedia("(min-width: 1233px)").matches
    ) {
      return;
    }

    this.details.classList.remove("open");
    this.details.classList.remove("opening");
    this.details.classList.add("closing");
    if (!this.closest("details")) this.removeBodyOverflow();
    // document.body.classList.remove("overflow-hidden");
    setTimeout(() => {
      this.details.removeAttribute("open");
      this.details.classList.remove("closing");
      this.details.classList.add("closed");
      if (this.classList.contains("has-modal")) {
        removeTrapFocus(this.details.querySelector("summary"));
      }
    }, 300);
    document.removeEventListener("click", this.clickOffListener);
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }
  // Fix to stop black flash when changing classes/styles of overflow hidden
  removeBodyOverflow() {
    const body = document.body;
    const afterEl = body;
    function onTransitionEnd(e) {
      if (e.propertyName === "opacity") {
        body.classList.remove("overflow-hidden");
        afterEl.removeEventListener("transitionend", onTransitionEnd);
      }
    }
    afterEl.addEventListener("transitionend", onTransitionEnd);
    body.classList.remove("overflow-hidden");
  }
}

customElements.define("gaia-dropdown", GaiaDropdown);

class GaiaSelect extends GaiaDropdown {
  constructor() {
    super();

    this.selectedOption = this.querySelector(".selected-option");
    this.fieldset = this.querySelector("fieldset");
    this.options = this.querySelector(".options");
    this.summary = this.querySelector("summary");
    //Looking for  <gaia-select data-subscription-widget="true"></gaia-select>
    this.isSubscriptionWidget = this.hasAttribute("data-subscription-widget");

    this.options.removeAttribute("tabindex");

    this.fieldset.addEventListener("change", (event) => {
      // Workaround for subscription widgets, as value is needed for adding correct subscription
      if (this.isSubscriptionWidget) {
        this.selectedOption.innerText =
          this.querySelector("input:checked").getAttribute("radio-name");
      } else {
        this.selectedOption.innerText =
          this.querySelector("input:checked").value.toLowerCase();
      }

      const radios = this.querySelectorAll('input[type="radio"]');
      radios.forEach((radio) => {
        radio.setAttribute("aria-selected", radio.checked ? "true" : "false");
      });
      // console.log(event.detail);
      // this.summary.click();
      if (this.details && this.details.open) {
        setTimeout(() => {
          this.details.open = false;
          if (this.summary) this.summary.focus();
        }, 0);
      }
    });

    // Focus trap for form-element dropdowns
    if (this.classList.contains("form-element")) {
      const details = this.querySelector("details");
      details.addEventListener("toggle", () => {
        if (details.open) {
          this.trapOptionsFocus();
        } else {
          this.removeOptionsFocusTrap();
        }
      });
    }
  }

  trapOptionsFocus() {
    const options = this.options;
    if (!options) return;

    // Remove any previous handler
    this.removeOptionsFocusTrap();

    this._optionsTrapHandler = (e) => {
      // Always get radios fresh
      const radios = Array.from(
        options.querySelectorAll('input[type="radio"]:not([disabled])'),
      );
      if (radios.length === 0) return;

      // Tab focus trap
      if (e.key === "Tab") {
        const currentIndex = radios.indexOf(document.activeElement);
        if (currentIndex === -1) return; // Not on a radio, let browser handle

        e.preventDefault();

        let nextIndex;
        if (e.shiftKey) {
          nextIndex = currentIndex === 0 ? radios.length - 1 : currentIndex - 1;
        } else {
          nextIndex = currentIndex === radios.length - 1 ? 0 : currentIndex + 1;
        }
        radios[nextIndex].focus();
      }

      // Enter/Space: select the focused radio, close dropdown, focus summary
      if (
        (e.key === "Enter" || e.key === " ") &&
        radios.includes(document.activeElement)
      ) {
        e.preventDefault();
        const radio = document.activeElement;
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
        // Close dropdown and focus summary
        const details = this.options.closest("details");
        if (details) {
          details.open = false;
          if (this.summary) this.summary.focus();
        }
      }

      // Escape: close the dropdown and focus summary
      if (e.key === "Escape" || e.key === "Esc") {
        e.preventDefault();
        const details = this.options.closest("details");
        if (details) {
          details.open = false;
          if (this.summary) this.summary.focus();
        }
      }
    };

    document.addEventListener("keydown", this._optionsTrapHandler);

    // Focus the checked radio or the first one
    const radios = Array.from(
      options.querySelectorAll('input[type="radio"]:not([disabled])'),
    );
    const checked = radios.find((r) => r.checked);
    (checked || radios[0])?.focus();
  }
  removeOptionsFocusTrap() {
    if (this._optionsTrapHandler) {
      document.removeEventListener("keydown", this._optionsTrapHandler);
      this._optionsTrapHandler = null;
    }
  }
}

customElements.define("gaia-select", GaiaSelect);

class GaiaMobileMenu extends GaiaDropdown {
  constructor() {
    super();
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector("details");
    if (detailsElement) {
      if (detailsElement.hasAttribute("open")) {
        detailsElement.setAttribute("aria-label", "Close Main Menu");
      } else {
        detailsElement.setAttribute("aria-label", "Open Main Menu");
      }
    }
  }

  open() {
    this.header =
      this.header ||
      document.querySelector(".shopify-section.section-header gaia-header");
    if (this.header)
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom)}px`,
      );
    super.open();
    this.updateAriaLabel();
    this.addTrapFocus();
  }

  close() {
    console.log("closing");
    super.close();
    this.removeTrapFocus();
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }

  addTrapFocus() {
    const container = this.querySelector("details");
    const focusable = getFocusableElements(container);
    const last = focusable[focusable.length - 1];

    if (last) {
      // Remove previous handler if any
      if (this._lastTabHandler) {
        last.removeEventListener("keydown", this._lastTabHandler);
      }
      this._lastTabHandler = (event) => {
        if (event.key === "Tab" && !event.shiftKey) {
          event.preventDefault();
          this.close();
        }
      };
      last.addEventListener("keydown", this._lastTabHandler);
    }
  }

  removeTrapFocus() {
    const container = this.querySelector("details");
    const focusable = getFocusableElements(container);
    const last = focusable[focusable.length - 1];
    if (last && this._lastTabHandler) {
      last.removeEventListener("keydown", this._lastTabHandler);
      this._lastTabHandler = null;
    }
  }
}

customElements.define("gaia-mobile-menu", GaiaMobileMenu);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {});
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    // document.body.classList.remove("overflow-hidden");
    this.removeBodyOverflow();
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
  // Fix to stop black flash when changing classes/styles of overflow hidden
  removeBodyOverflow() {
    const body = document.body;
    const afterEl = body;
    function onTransitionEnd(e) {
      if (e.propertyName === "opacity") {
        body.classList.remove("overflow-hidden");
        afterEl.removeEventListener("transitionend", onTransitionEnd);
      }
    }
    afterEl.addEventListener("transitionend", onTransitionEnd);
    body.classList.remove("overflow-hidden");
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class TotalPrice extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.updatePrice);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes") {
          mutation.target.updatePrice();
        }
      });
    });

    observer.observe(this, { attributes: true });

    this.updatePrice();
  }

  updatePrice() {
    if (
      !this.dataset.subscriptionDiscount ||
      this.dataset.subscriptionDiscount == "undefined"
    )
      this.dataset.subscriptionDiscount = 0;
    this.innerText = `£${(
      Math.round(
        (this.dataset.basePrice *
          (100 - this.dataset.subscriptionDiscount) *
          this.dataset.quantity) /
          100,
      ) / 100
    ).toFixed(2)}`;
  }
}

customElements.define("total-price", TotalPrice);

class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onSubscriptionChange);
    this.onSubscriptionChange();
  }

  onSubscriptionChange(sync = true) {
    let selected_type = this.querySelector(
      ".subscription-selector input:checked",
    );
    let subscription_options = this.querySelector(".subscription-options");
    let subscription_radios = subscription_options.querySelectorAll(
      'input[name="selling_plan"]',
    );
    let subscription_note = this.querySelector(".subscription-note");

    // Show/Hide subscription frequency options on what purchase type is selected
    if (selected_type.value == "onetime") {
      console.log("one time selected");
      subscription_options.classList.add("visually-hidden");
      // Uncheck all radios
      subscription_radios.forEach((radio) => {
        radio.checked = false;
      });
    } else if (selected_type.value == "subscription") {
      // Show subscription selector
      subscription_options.classList.remove("visually-hidden");
      // Check if any are checked, if not default check the first option
      let anySelected = Array.from(subscription_radios).some(
        (radio) => radio.checked,
      );
      if (!anySelected && subscription_radios.length > 0) {
        subscription_radios[0].checked = true;
      }
    }

    // Update other widgets
    let widgets = document.querySelectorAll("subscription-widget");
    if (sync) {
      widgets.forEach((widget) => {
        if (widget != this) {
          // Update the purchase type radio button
          widget.querySelector(
            `.purchase-type input[value="${selected_type.value}"]`,
          ).checked = true;
          // Update the selling plan radio buttons
          let widget_radios = widget.querySelectorAll(
            'input[name="selling_plan"]',
          );
          let selected_radio = Array.from(subscription_radios).find(
            (radio) => radio.checked,
          );
          if (selected_radio) {
            widget.querySelector(
              `input[name="selling_plan"][value="${selected_radio.value}"]`,
            ).checked = true;
          } else {
            // If no radio is selected, select the first one
            if (widget_radios.length > 0) {
              widget_radios[0].checked = true;
            }
          }
          widget.onSubscriptionChange(false);
        }
      });
    }
  }
}

customElements.define("subscription-widget", SubscriptionWidget);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.isSyncing = false; // Add a flag to track syncing state
    this.addEventListener("change", (event) => {
      if (!this.isSyncing) {
        // console.log("Variant changed:", event.target);
        this.onVariantChange();
      }
    });
    this.onVariantChange();
    this.keyboardSupport();
  }

  onVariantChange() {
    this.syncInputs();
    setTimeout(() => {
      this.updateOptions();
      this.updateMasterId();
      this.updateColor();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateInventory();

      if (!this.currentVariant) {
        console.warn("Invalid variant combination selected", {
          section: this.dataset.section,
          selectedOptions: this.options,
          optionCount: this.options?.length || 0,
        });
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
        this.hideInventoryBar();
      } else {
        this.showInventoryBar();
        this.updateBundleOptions();
        this.updateMedia();
        this.updateContent();
        this.updatePricing();
        this.updateSubscriptionPricing();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
        this.setAvailableOptions();
      }
    }, 200); // Delay to ensure syncInputs completes
  }

  keyboardSupport() {
    const labels = this.querySelectorAll("label");
    labels.forEach((label) => {
      label.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          const inputId = label.getAttribute("for");
          const input = document.getElementById(inputId);
          if (input && input.type === "radio") {
            input.checked = true;
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      });
    });
  }

  syncInputs() {
    // console.log("Syncing input...");
    this.isSyncing = true; // Stop a loop

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-sticky_atc, #product-form-installment-${this.dataset.section}`,
    );
    // console.log("Product forms found:", productForms);

    const thisFieldsets = this.querySelectorAll("fieldset");
    const thisSelects = this.querySelectorAll("gaia-select");

    productForms?.forEach((productForm) => {
      const variantRadios = productForm.querySelectorAll("variant-radios");
      // console.log("Variant radios found:", variantRadios);

      variantRadios?.forEach((variantRadio) => {
        if (variantRadio && variantRadio !== this) {
          const targetFieldsets = variantRadio.querySelectorAll("fieldset");
          const targetSelects = variantRadio.querySelectorAll("gaia-select");

          // Sync fieldsets
          // Sync fieldsets
          targetFieldsets.forEach((targetFieldset, i) => {
            const thisValue = thisFieldsets[i]?.querySelector(
              "input[type=radio]:checked",
            )?.value;
            // console.log(`Syncing fieldset ${i}:`, thisValue);
            if (thisValue) {
              const targetInput = targetFieldset.querySelector(
                `input[value="${CSS.escape(thisValue)}"]`,
              );
              if (targetInput) {
                // Set checked state and dispatch event
                targetInput.checked = true;
                targetInput.dispatchEvent(
                  new Event("change", { bubbles: true }),
                );

                // Remove .is-checked from all radios in this group in this fieldset
                targetFieldset
                  .querySelectorAll("input[type=radio]")
                  .forEach((radio) => {
                    radio.classList.remove("is-checked");
                    const label = targetFieldset.querySelector(
                      `label[for="${radio.id}"]`,
                    );
                    if (label) {
                      label.classList.remove("is-checked");
                      const swatchImgs =
                        label.getElementsByClassName("swatch-img");
                      for (let swatchImg of swatchImgs) {
                        swatchImg.setAttribute("aria-checked", "false");
                      }
                    }
                  });

                // Add .is-checked to the checked input and its label
                targetInput.classList.add("is-checked");
                const checkedLabel = targetFieldset.querySelector(
                  `label[for="${targetInput.id}"]`,
                );
                if (checkedLabel) checkedLabel.classList.add("is-checked");
                checkedLabel.getAttribute("aria-checked", true);
                const checkedSwatchImgs =
                  checkedLabel.getElementsByClassName("swatch-img");
                for (let swatchImg of checkedSwatchImgs) {
                  swatchImg.setAttribute("aria-checked", "true");
                }
              }
            }
          });

          // Sync gaia-selects
          targetSelects.forEach((targetSelect, i) => {
            const thisValue = thisSelects[i]?.querySelector(
              "input[type=radio]:checked",
            )?.value;
            // console.log(`Syncing gaia-select ${i}:`, thisValue);
            if (thisValue) {
              const targetInput = targetSelect.querySelector(
                `input[value="${CSS.escape(thisValue)}"]`,
              );
              if (targetInput) {
                targetInput.checked = true;
                targetInput.dispatchEvent(
                  new Event("change", { bubbles: true }),
                );

                // Remove .is-checked from all radios in this gaia-select
                targetSelect
                  .querySelectorAll("input[type=radio]")
                  .forEach((radio) => {
                    radio.classList.remove("is-checked");
                    const label = targetSelect.querySelector(
                      `label[for="${radio.id}"]`,
                    );
                    if (label) label.classList.remove("is-checked");
                  });

                // Add .is-checked to the checked input and its label
                targetInput.classList.add("is-checked");
                const checkedLabel = targetSelect.querySelector(
                  `label[for="${targetInput.id}"]`,
                );
                if (checkedLabel) checkedLabel.classList.add("is-checked");
              }
            }
          });
        }
      });
    });

    this.isSyncing = false; // Reset the flag after syncing is complete
  }

  updateColor() {
    const swatchPickers = this.querySelectorAll("fieldset.swatch-picker");

    swatchPickers.forEach((fieldset) => {
      // Find the selected input within the fieldset
      const selectedInput = fieldset.querySelector("input[type=radio]:checked");
      if (selectedInput) {
        // Update the legend with the new selected value
        const legend = fieldset.querySelector("legend.label");
        if (legend) {
          const optionName = legend.dataset.optionName || "Color";
          legend.innerHTML = `${optionName}: ${selectedInput.value}`;
        }
      }
    });
  }

  setAvailableOptions() {
    // Reset unavailable classes
    this.querySelectorAll('input[type="radio"]').forEach((option) => {
      option.classList.remove("unavailable");
    });

    this.variantData.forEach((variant) => {
      if (!variant.available) {
        variant.options.forEach((option, index) => {
          const fieldset = this.querySelectorAll("fieldset")[index];
          const gaiaSelect = this.querySelectorAll("gaia-select")[index];

          // Handle fieldsets
          if (fieldset) {
            const input = getInputByValue(fieldset, option);
            if (input) input.classList.add("unavailable");
          }

          // Handle gaia-selects
          if (gaiaSelect) {
            const input = getInputByValue(gaiaSelect, option);
            if (input) input.classList.add("unavailable");
          }
        });
      }
    });
  }

  // On variant change, get the progress bar (PDP block) and update to the latest variant's quantity
  updateInventory() {
    const variant = this.currentVariant;
    if (!variant) return;
    const section = document.querySelector(
      `#shopify-section-${this.dataset.section}`,
    );
    if (!section) return;
    const inventoryList = section.querySelector(".product__inventory");
    if (!inventoryList) return;
    const progressBar = inventoryList.querySelector("progress-bar");
    if (!progressBar) return;

    // JSON helper in main-product.liquid under the block code snippet, it holds each variant's inventory quantity.
    // Match the currentVariant to the helper data to get the quantity
    const inventoryJsonEl = section.querySelector(
      `#variant-inventory-json-${this.dataset.section}`,
    );
    let inventoryData = {};
    if (inventoryJsonEl) {
      try {
        inventoryData = JSON.parse(inventoryJsonEl.textContent);
      } catch (e) {
        // console.log("[Update Inventory] Failed to parse inventory JSON", e);
      }
    }
    const quantity =
      inventoryData[variant.id] !== undefined ? inventoryData[variant.id] : 0;
    progressBar.setAttribute("data-quantity", quantity);

    // Get threshold from data attribute, 5 as a backup
    let threshold = 10;
    let thresholdEl = inventoryList.closest("[data-inventory-threshold]");
    let attr = null;
    if (thresholdEl) {
      attr = thresholdEl.getAttribute("data-inventory-threshold");
    }
    // If not found on parent, check the progressBar element itself
    if (!attr || attr === null) {
      if (progressBar.hasAttribute("data-inventory-threshold")) {
        attr = progressBar.getAttribute("data-inventory-threshold");
      }
    }
    if (attr !== null) {
      threshold = parseInt(attr);
      if (isNaN(threshold)) {
        threshold = 5;
      }
    } else if (progressBar.hasAttribute("data-threshold")) {
      const attr2 = progressBar.getAttribute("data-threshold");

      threshold = parseInt(attr2);
      if (isNaN(threshold)) {
        threshold = 5;
      }
    }
    progressBar.setAttribute("data-threshold", threshold);

    // Update inventory-count
    const inventoryCountEl = inventoryList.querySelector(".inventory-count");
    if (inventoryCountEl) {
      inventoryCountEl.textContent = quantity;
    }

    // Calculate and set --progress-bar-width
    // Find the max quantity among all variants for this product
    const maxQuantity = Math.max(...Object.values(inventoryData));
    let widthPercent = 100;
    if (maxQuantity > 0) {
      widthPercent = Math.max(5, Math.round((quantity / maxQuantity) * 100));
    }
    progressBar.style.setProperty("--progress-bar-width", widthPercent + "%");

    // Set progress bar color (same logic as ProgressBar class)
    let color = "green";
    if (quantity === 0) {
      color = "red";
    } else if (quantity <= threshold) {
      color = "orange";
    }
    progressBar.style.setProperty("--progress-bar", color);

    // Update messaging and announce changes for accessibility
    const wrapper = document.querySelector(".product__inventory-item");
    if (wrapper) {
      const high = wrapper.querySelector(".inventory-high");
      const low = wrapper.querySelector(".inventory-low");
      const out = wrapper.querySelector(".inventory-out");
      const statusMessage = wrapper.querySelector("#inventory-status-message");
      if (high && low && out && statusMessage) {
        // Hide all first
        high.classList.remove("active");
        high.classList.add("hidden");
        high.setAttribute("aria-hidden", "true");
        low.classList.remove("active");
        low.classList.add("hidden");
        low.setAttribute("aria-hidden", "true");
        out.classList.remove("active");
        out.classList.add("hidden");
        out.setAttribute("aria-hidden", "true");

        let message = "";
        if (quantity === 0) {
          out.classList.add("active");
          out.classList.remove("hidden");
          out.setAttribute("aria-hidden", "false");
          message = out.textContent.trim();
        } else if (quantity <= threshold) {
          low.classList.add("active");
          low.classList.remove("hidden");
          low.setAttribute("aria-hidden", "false");
          message = low.textContent.trim();
        } else {
          high.classList.add("active");
          high.classList.remove("hidden");
          high.setAttribute("aria-hidden", "false");
          message = high.textContent.trim();
        }
        // Announce the change for screen readers
        statusMessage.textContent = message;
      }
    }
  }

  hideInventoryBar() {
    console.log("Hiding inventory bar");
    const inventoryList = document.querySelector(".product__inventory");
    console.log("Inventory list found:", inventoryList);
    if (!inventoryList) return;
    inventoryList.classList.add("visually-hidden");
  }

  showInventoryBar() {
    console.log("Showing inventory bar");
    const inventoryList = document.querySelector(".product__inventory");
    console.log("Inventory list found:", inventoryList);
    if (!inventoryList) return;
    inventoryList.classList.remove("visually-hidden");
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const selects = Array.from(this.querySelectorAll("gaia-select"));

    console.log("Fieldsets found:", fieldsets);
    console.log("Gaia-selects found:", selects);

    // Handle fieldsets (radio buttons)
    const fieldsetOptions = fieldsets.map((fieldset) => {
      const checkedInput = fieldset.querySelector("input[type=radio]:checked");
      console.log("Checked input in fieldset:", checkedInput);
      return checkedInput ? checkedInput.value : null;
    });

    // Handle gaia-select (dropdowns)
    const selectOptions = selects.map((select) => {
      // Check if gaia-select uses a custom structure
      const selectedOption =
        select.querySelector("input[type=radio]:checked") ||
        select.querySelector(".selected-option"); // Adjust as needed
      console.log("Checked input in gaia-select:", selectedOption);
      return selectedOption
        ? selectedOption.value || selectedOption.innerText
        : null;
    });

    // Combine options from both layouts
    this.options = [...fieldsetOptions, ...selectOptions].filter(
      (option) => option !== null,
    );

    // Debugging: Log the selected options
    console.log("Selected Options:", this.options);
    const testselects = Array.from(this.querySelectorAll("gaia-select"));
    testselects.forEach((select, index) => {
      console.log(`Gaia-select ${index}:`, select);
      console.log(`Gaia-select ${index} children:`, select.children);
    });
  }

  updateMasterId() {
    const variantData = this.getVariantData();

    // Ensure the selected options are ordered correctly
    const productOptions = variantData[0]?.options || []; // Get the order of options from the first variant
    const orderedOptions = productOptions.map((optionName, index) => {
      return this.options[index];
    });

    // Find the matching variant
    this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return orderedOptions[index] === option;
        })
        .includes(false);
    });

    if (!this.currentVariant) {
      console.warn("Variant not found", {
        section: this.dataset.section,
        selectedOptions: this.options,
        orderedOptions,
        variantCount: variantData.length,
      });
    }
  }

  updateMedia(speed = 300) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`,
    );
    const media = mediaGallery.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)",
    );
    const variantSlide = getVariantMediaSlide(media, this.currentVariant);
    mediaGallery.swiper?.slideTo(variantSlide, speed);

    function getVariantMediaSlide(media, variant) {
      let i;
      for (i = 0; i < media.length; i++) {
        for (let v of JSON.parse(media[i].dataset.variants)) {
          if (v == variant.id) {
            return i;
          }
        }
      }
    }

    return variantSlide;
  }

  updateContent() {
    if (!this.currentVariant) return;

    const targets = document.querySelectorAll(
      `#shopify-section-${this.dataset.section} .variant-content`,
    );

    targets.forEach((content) => {
      if (content.dataset.variant == this.currentVariant.id) {
        content.classList.remove("hidden");
      } else {
        content.classList.add("hidden");
      }
    });
  }

  updatePricing() {
    if (!this.currentVariant) return;

    // console.log(`#shopify-section-${this.dataset.section} .pricing`);
    const pricings = document.querySelectorAll(
      `#shopify-section-${this.dataset.section} .pricing`,
    );
    pricings.forEach((pricing) => {
      if (pricing.dataset.variantId == this.currentVariant.id) {
        pricing.classList.add("active");

        const total_prices = document.querySelectorAll("total-price");
        total_prices.forEach((total_price) => {
          total_price.dataset.basePrice =
            pricing.querySelector(".price-current").dataset.price;
        });
      } else {
        pricing.classList.remove("active");
      }
    });
  }

  updateSubscriptionPricing() {
    if (!this.currentVariant) return;

    const prices = document.querySelectorAll(`.subscribe-price`);
    prices.forEach((price) => {
      if (price.dataset.variant == this.currentVariant.id) {
        price.classList.remove("visually-hidden");
      } else {
        price.classList.add("visually-hidden");
      }
    });
  }

  updateBundleOptions() {
    if (!this.currentVariant) return;

    const bundles = document.querySelectorAll(".simple-bundles");
    bundles.forEach((bundle) => {
      if (bundle.dataset.variant == this.currentVariant.id) {
        bundle.classList.add("active");
      } else {
        bundle.classList.remove("active");
      }

      const hiddenInputs = bundle.querySelectorAll('input[type="hidden"]');
      hiddenInputs.forEach((hiddenInput) => {
        if (bundle.dataset.variant == this.currentVariant.id) {
          hiddenInput.removeAttribute("disabled");
        } else {
          hiddenInput.setAttribute("disabled", true);
        }
      });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl != "true") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-sticky_atc, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const allowedMarkets = ["usa", "gb", "canada", "eu"];
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-sticky_atc`,
    );
    if (!productForms) return;
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      // Disable on other markets logic
      const market = addButton.getAttribute("data-market");
      if (market) {
        // Only enable for allowedMarkets
        if (!allowedMarkets.includes(market)) {
          addButton.setAttribute("disabled", "disabled");
          if (addButtonText) addButtonText.textContent = text;
          return;
        }
      }

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = text;
      } else if (!addButton.classList.contains("multi-bundle-disabled")) {
        addButton.removeAttribute("disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    });

    if (!modifyClass) return;
  }

  setUnavailable() {
    const buttons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-sticky_atc`,
    );
    buttons.forEach((button) => {
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
    });
  }

  getVariantData() {
    const scriptElement = this.querySelector('[type="application/json"]');
    if (!scriptElement) {
      console.error(
        "Variant data script element not found within variant-radios.",
      );
      return [];
    }
    try {
      this.variantData = JSON.parse(scriptElement.textContent);
      return this.variantData;
    } catch (error) {
      console.error("Error parsing variant data JSON:", error);
      return [];
    }
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setAvailableOptions() {
    // Reset unavailable classes
    this.querySelectorAll('input[type="radio"]').forEach((option) => {
      option.classList.remove("unavailable");
    });

    this.variantData.forEach((variant) => {
      if (!variant.available) {
        variant.options.forEach((option, index) => {
          const fieldset = this.querySelectorAll("fieldset")[index];
          const gaiaSelect = this.querySelectorAll("gaia-select")[index];

          // Handle fieldsets
          if (fieldset) {
            const input = getInputByValue(fieldset, option);
            if (input) input.classList.add("unavailable");
          }

          // Handle gaia-selects
          if (gaiaSelect) {
            const input = getInputByValue(gaiaSelect, option);
            if (input) input.classList.add("unavailable");
          }
        });
      }
    });
  }

  updateOptions() {
    // Collect all fieldsets, including those inside gaia-select
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    // Extract selected options from all fieldsets
    this.options = fieldsets
      .map((fieldset) => {
        const checkedInput = fieldset.querySelector(
          "input[type=radio]:checked",
        );
        return checkedInput ? checkedInput.value : null;
      })
      .filter((option) => option !== null); // Remove null values

    // console.log("Selected Options:", this.options);
  }
}

customElements.define("variant-radios", VariantRadios);

class VariantDetails extends VariantRadios {
  constructor() {
    super();
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) =>
        variant.id == this.querySelector("input.variant-detail:checked").value,
    );
  }

  setAvailableOptions() {
    return null;
  }
}

customElements.define("variant-details", VariantDetails);

class VariantSingleSelect extends VariantSelects {
  constructor() {
    super();
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) => variant.id == this.querySelector("select").value,
    );
  }
}

customElements.define("variant-single-select", VariantSingleSelect);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    setTimeout(() => {
      const quantity = parseInt(this.dataset.quantity);
      const threshold = parseInt(this.dataset.threshold) || 5;

      // Update progress bar width (fallback logic)
      let progerss_width;
      if (quantity === 0) progerss_width = 100;
      else {
        progerss_width = (quantity * 100) / 30;
        if (progerss_width > 100) progerss_width = 100;
      }
      this.style.setProperty("--progress-bar-width", `${progerss_width}%`);

      // Set progress bar color
      let color = "green";
      if (quantity === 0) {
        color = "red";
      } else if (quantity <= threshold) {
        color = "orange";
      }
      console.log(
        "Setting progress bar color to:",
        color,
        "for quantity:",
        quantity,
        "and threshold:",
        threshold,
      );
      this.style.setProperty("--progress-bar", color);
    }, 100);
  }
}
customElements.define("progress-bar", ProgressBar);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

function getCookie(name) {
  var cookieArr = document.cookie.split(";");

  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");

    if (name == cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

// Set trap focus within the elements. Call it with the element you want to focus within (e.g modal).
function addFocusTrap(focusElement) {
  // Remove any existing focus trap globally
  if (this._trapFocus) {
    document.removeEventListener("keydown", this._trapFocus);
    this._trapFocus = null;
  }

  // Get all focusable elements inside focusElement
  const focusableSelectors = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"])',
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "iframe",
    "object",
    "embed",
    '[tabindex]:not([tabindex^="-"])',
    "[contenteditable]",
  ];
  const focusableElements = Array.from(
    focusElement.querySelectorAll(focusableSelectors.join(",")),
  ).filter((el) => el.offsetParent !== null);

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  const trapFocus = (event) => {
    if (event.key === "Tab") {
      if (focusableElements.length === 0) return;
      if (event.shiftKey) {
        // Shift + Tab
        if (
          document.activeElement === firstElement ||
          document.activeElement === focusElement
        ) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    }
  };

  document.addEventListener("keydown", trapFocus);
  this._trapFocus = trapFocus;

  // Set initial focus to the first focusable element
  if (firstElement) {
    firstElement.focus();
  }
}

// Remove a trap focus
function removeFocusTrap(nextFocusElement) {
  if (this._trapFocus) {
    document.removeEventListener("keydown", this._trapFocus);
    this._trapFocus = null;
  }
  if (nextFocusElement) {
    nextFocusElement.focus();
  }
}
